import { LocationData } from './location-data';

export class SpeedTestData {
  username: string;
  mac?: null;
  workorder: string;
  location: string;
  locationComment: string;
  account?: null;
  timestamp: number;
  uploadTimestamp: number;
  latitude: number;
  longitude: number;
  locationData: Partial<LocationData>;
  downloadSpeed: number;
  uploadSpeed: number;
  maxDownstream: number;
  avgDownstream: number;
  maxUpstream: number;
  avgUpstream: number;
  latency: number;
  source: string;
  dsofdm: number;
  dsscqam: number;
  usscqam: number;
  downstream?: StreamEntity[] | null;
  upstream?: StreamEntity[] | null;

  constructor(httpResponse: SpeedTestData) {
    // @ts-ignore
    this.username = httpResponse['userId'] as string;
    this.account = httpResponse.account;
    this.downloadSpeed = httpResponse.downloadSpeed;
    this.downstream = httpResponse.downstream;
    this.dsofdm = httpResponse.dsofdm;
    this.dsscqam = httpResponse.dsscqam;
    this.latency = httpResponse.latency;
    this.latitude = httpResponse.latitude;
    this.location = httpResponse.location;
    this.locationComment = httpResponse.locationComment;
    this.locationData = httpResponse.locationData;
    this.longitude = httpResponse.longitude;
    this.mac = httpResponse.mac;
    this.source = httpResponse.source;
    this.timestamp = httpResponse.timestamp;
    this.uploadSpeed = httpResponse.uploadSpeed;
    this.uploadTimestamp = httpResponse.uploadTimestamp;
    this.upstream = httpResponse.upstream;
    this.usscqam = httpResponse.usscqam;
    this.avgDownstream = httpResponse.avgDownstream;
    this.maxDownstream = httpResponse.maxDownstream;
    this.avgUpstream = httpResponse.avgUpstream;
    this.maxUpstream = httpResponse.maxUpstream;
  }
}
export interface StreamEntity {
  type: 'QAM' | 'OFDM' | 'OFDM1' | 'OFDM2' | 'ETHERNET' | 'OFDMA' | 'RF';
  megabitsPerSecond?: number[] | null;
  isOmittedPerSecond?: boolean[] | null;
  frequency: number;
  averageMbps: number;
  maxMbps: number;
  minMbps: number;
  direction: string;
}
